var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBestvalue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "24 37 152 126",
    viewBox: "0 0 200 200",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7ED",
    d: "M40.122 147.143h108.294L155.593 163l7.356-15.857H176V60.987H40.122v86.156z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.939 68.049l-74.044 1.525-9.747 4.353-2.25-6.944 5.755-7.169 76.387-16.475 3.899 24.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7ED",
    d: "M123.939 66.678H45.828l-5.68 7.249-5.82-7.249H24V37h99.939v29.678z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.965 77.939h15.303c6.626 0 9.978 3.593 9.978 8.49 0 3.119-1.459 5.212-3.747 6.476 3.116 1.185 5.127 3.554 5.127 7.147 0 5.094-3.786 8.687-10.018 8.687H47.965v-30.8zm7.888 7.186v4.896h6.508c2.13 0 2.919-.987 2.919-2.448s-.828-2.448-2.485-2.448h-6.942zm0 11.057v5.41h7.888c2.13 0 2.919-1.145 2.919-2.764 0-1.579-.789-2.646-2.919-2.646h-7.888z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.773 77.939h23.625v7.66H88.661v4.423h12.936v7.147H88.661v3.949h15.737v7.621H80.773v-30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.446 99.499v.197c0 1.185 1.617 2.804 5.206 2.804 2.958 0 3.905-.987 3.905-1.895 0-1.303-1.538-2.093-5.246-3.356-4.891-1.619-11.319-3.988-11.319-10.346 0-5.884 5.009-9.556 12.029-9.556 7.178 0 12.581 3.83 12.581 9.951v.434h-7.691v-.276c0-1.501-1.538-3.277-4.733-3.277-2.682 0-3.747 1.066-3.747 2.093 0 1.224 1.42 1.856 5.088 3.119 4.26 1.501 11.517 4.028 11.517 10.78 0 6.002-5.206 9.161-12.226 9.161-7.375 0-13.055-3.435-13.055-9.477V99.5h7.691z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.408 77.939h27.056v7.66h-9.584v23.139h-7.888V85.599h-9.584v-7.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.58 140.097l-9.673-23.981h6.694l6.019 16.11 6.05-16.11h6.694l-9.704 23.981h-6.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.034 116.116l9.673 23.981h-6.694l-1.32-3.505h-9.428l-1.321 3.505H70.25l9.704-23.981h6.08zm-3.04 7.871l-2.641 7.04h5.252l-2.611-7.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.704 116.116h6.111v18.047H117.3v5.934H99.704v-23.981z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.884 116.116v13.497c0 6.18-3.869 10.945-11.024 10.945-7.186 0-10.994-4.765-10.994-10.945v-13.497h6.141v13.128c0 3.474 1.658 5.38 4.852 5.38 3.224 0 4.913-1.906 4.913-5.38v-13.128h6.112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.386 116.116h18.395v5.965h-12.253v3.443H164.6v5.564h-10.072v3.075h12.253v5.934h-18.395v-23.981z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.394 43.339l2.482 5.035 5.549.807-4.016 3.919.948 5.533-4.963-2.612-4.964 2.612.948-5.533-4.015-3.919 5.549-.807 2.482-5.035z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.311 43.339l2.482 5.035 5.549.807-4.015 3.919.948 5.533-4.964-2.612-4.963 2.612.948-5.533-4.016-3.919 5.55-.807 2.481-5.035z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.229 43.339l2.481 5.035 5.549.807-4.015 3.919.948 5.533-4.963-2.612-4.964 2.612.948-5.533-4.015-3.919 5.549-.807 2.482-5.035z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.146 43.339l2.482 5.035 5.549.807-4.016 3.919.948 5.533-4.963-2.612-4.963 2.612.947-5.533-4.015-3.919 5.549-.807 2.482-5.035z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.063 43.339l2.482 5.035 5.549.807-4.015 3.919.948 5.533-4.964-2.612-4.963 2.612.948-5.533-4.016-3.919 5.55-.807 2.481-5.035z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestvalue);
export default __webpack_public_path__ + "static/media/bestvalue.5742e2a32f65fd06447c5fbf992f219f.svg";
export { ForwardRef as ReactComponent };